<template>
  <div class="page" style="height: 100%">
    <div class="page__bd" style="height: 100%">
      <div class="weui-tab">
        <div
          class="weui-search-bar"
          id="searchBar"
          :class="{ 'weui-search-bar_focusing': searchActive }"
        >
          <feather-arrow-left
            style="height: 32px; width: 32px"
            @click="this.$router.go(-1)"
          ></feather-arrow-left
          >&nbsp;&nbsp;
          <feather-refresh-cw
            style="height: 32px; width: 32px"
            @click="this.$router.go(0)"
            :title="refreshTitle"
          ></feather-refresh-cw
          >&nbsp;&nbsp;
          <!-- <a
            href="javascript:"
            class="weui-search-bar__cancel-btn"
            @click="this.$router.go(-1)"
          >返回&nbsp;</a>-->
          <form class="weui-search-bar__form">
            <div class="weui-search-bar__box">
              <i class="weui-icon-search"></i>
              <input
                type="search"
                class="weui-search-bar__input"
                v-model="this.$store.state.keyword"
                required
              />
              <a
                href="javascript:"
                class="weui-icon-clear"
                @click="clearSearch"
              ></a>
            </div>
            <label
              class="weui-search-bar__label"
              @click="searchActive = true"
              id="searchText"
            >
              <i class="weui-icon-search"></i>
              <span>{{ $t("search") }}</span>
            </label>
          </form>
          <!-- <a
            href="javascript:"
            @click="clearSearch"
            class="weui-search-bar__cancel-btn"
            id="searchCancel"
          >取消</a>-->
          <!-- <select
            class="weui-select"
            style="background-color:#191919;padding-left:0px;height: 32px;width: 64px;line-height:0px"
            @change="setLang(lang)"
            v-model="lang"
          >
            <option selected value="zh-cn">中文</option>
            <option value="en-us">English</option>
          </select>-->
          <feather-menu
            style="height: 32px; width: 32px"
            @click="menuActive = true"
            title="菜单"
          ></feather-menu>
        </div>
        <!--BEGIN actionSheet-->
        <div @click="hideMenu">
          <div class="weui-mask" id="iosMask" v-if="menuActive"></div>
          <div
            role="dialog"
            aria-modal="true"
            class="weui-skin_android"
            v-if="menuActive"
            position="relative"
          >
            <div
              id="androidClose"
              role="option"
              aria-label="关闭"
              class="weui-mask"
            ></div>
            <div class="weui-actionsheet">
              <div class="weui-actionsheet__menu">
                <div
                  role="button"
                  class="weui-actionsheet__cell"
                  @click.prevent="setLang('zh-cn')"
                >
                  中文{{ showZHCheck }}
                </div>
                <div
                  role="button"
                  class="weui-actionsheet__cell"
                  @click.prevent="setLang('en-us')"
                >
                  English{{ showENCheck }}
                </div>
                <div
                  style="color: Red; cursor: pointer"
                  role="button"
                  class="weui-actionsheet__cell"
                  @click="signout"
                >
                  {{ $t("logout") }}
                </div>
                <div
                  role="button"
                  style="color: White; cursor: pointer"
                  class="weui-actionsheet__cell"
                  @click="hideMenu"
                >
                  {{ $t("cancel") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--END actionSheet-->
        <div class="weui-tab__panel">
          <router-view></router-view>
        </div>
        <div class="weui-tabbar" v-show="loggedIn">
          <div
            @click="deviceClick"
            class="weui-tabbar__item"
            v-bind:class="{ 'weui-bar__item_on': deviceActive }"
          >
            <!-- <img src="/static/images/device.png" alt="" class="weui-tabbar__icon"> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              alt
              class="weui-tabbar__icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            <p class="weui-tabbar__label">{{ $t("device") }}</p>
          </div>
          <div
            @click="sdwanClick"
            class="weui-tabbar__item"
            v-bind:class="{ 'weui-bar__item_on': sdwanActive }"
          >
            <!-- <img src="/static/images/device.png" alt="" class="weui-tabbar__icon"> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              alt
              class="weui-tabbar__icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
              />
            </svg>
            <p class="weui-tabbar__label">{{ $t("sdwan.tabName") }}</p>
          </div>
          <div
            @click="installClick"
            class="weui-tabbar__item"
            v-bind:class="{ 'weui-bar__item_on': installActive }"
          >
            <div style="display: inline-block; position: relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                alt
                class="weui-tabbar__icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                />
              </svg>
              <span
                v-if="showBadge"
                class="weui-badge weui-badge_dot"
                style="position: absolute; top: 0; right: -6px"
              ></span>
            </div>
            <p class="weui-tabbar__label">{{ $t("install") }}</p>
          </div>
          <div
            @click="profileClick"
            class="weui-tabbar__item"
            v-bind:class="{ 'weui-bar__item_on': profileActive }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              alt
              class="weui-tabbar__icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <p class="weui-tabbar__label">{{ $t("profile") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "./auth.js"
export default {
  name: "App",
  data() {
    return {
      searchActive: false,
      menuActive: false,
      search: "",
      lang: "zh-cn",
    }
  },
  components: {},
  mounted() {
    this.$nextTick(() => {
      const currentPath = this.$route.path
      window.debugLog("currentPath:", currentPath)
      if (currentPath === "/device") {
        this.activeTab = "device"
      } else if (currentPath === "/sdwan") {
        this.activeTab = "sdwan"
      } else if (currentPath === "/install") {
        this.activeTab = "install"
      } else if (currentPath === "/profile") {
        this.activeTab = "profile"
      }
    })
  },
  computed: {
    showBadge() {
      return this.$store.state.nodes.length > 2 ? false : true
    },
    loggedIn() {
      return this.$store.state.token.exp > Date.now() / 1000
    },
    showZHCheck() {
      if (this.$i18n.locale == "zh-cn") {
        return " ✓"
      }
      return ""
    },
    showENCheck() {
      if (this.$i18n.locale == "en-us") {
        return " ✓"
      }
      return ""
    },
    refreshTitle() {
      return this.$t("refresh")
    },
    deviceActive() {
      return this.$route.path === "/device"
    },
    sdwanActive() {
      return this.$route.path === "/sdwan"
    },
    installActive() {
      return this.$route.path === "/install"
    },
    profileActive() {
      return this.$route.path === "/profile"
    },
  },
  methods: {
    clearSearch() {
      this.search = ""
      this.searchActive = false
      this.$store.commit("setKeyword", "")
    },
    deviceClick() {
      this.$router.push("/device")
    },
    sdwanClick() {
      this.$router.push("/sdwan")
    },
    installClick() {
      this.$router.push("/install")
    },
    profileClick() {
      this.$router.push("/profile")
    },
    hideMenu() {
      this.menuActive = false
      window.debugLog("hideMenu:", this.menuActive)
    },
    signout() {
      this.menuActive = false
      auth.logout()
      this.$store.commit("setToken", {})
      window.location.href = "/login"
      window.debugLog("signout")
    },
    setLang(lang) {
      window.debugLog("setlang:", lang)
      this.$i18n.locale = lang
      localStorage.setItem("locale", lang)
    },
  },
}
</script>
<style scoped>
/* 添加自定义样式 */
.weui-search-bar {
  /* 设置文本颜色 */
  color: #f7f3f3;
}

/* 如果需要进一步调整搜索栏的亮度，可以添加其他样式 */
</style>
<style scoped>
@import "assets/css/weui.scss";
</style>